

const ownHouse = {
  Su: [{ label: "❤️ 🏠", x: 429, y: 347 }],
  "(Su)": [{ label: "❤️ 🏠", x: 429, y: 347 }],
  Mo: [{ label: "❤️ 🏠", x: 429, y: 231 }],
  "(Mo)": [{ label: "❤️ 🏠", x: 429, y: 231 }],
  Me: [
    { label: "❤️ 🏠", x: 429, y: 115 },
    { label: "❤️ 🏠", x: 429, y: 463 },
  ],
  "(Me)": [
    { label: "❤️ 🏠", x: 429, y: 115 },
    { label: "❤️ 🏠", x: 429, y: 463 },
  ],
  Ve: [
    { label: "❤️ 🏠", x: 313, y: 115 },
    { label: "❤️ 🏠", x: 313, y: 463 },
  ],
  "(Ve)": [
    { label: "❤️ 🏠", x: 313, y: 115 },
    { label: "❤️ 🏠", x: 313, y: 463 },
  ],
  Ma: [
    { label: "❤️ 🏠", x: 197, y: 115 },
    { label: "❤️ 🏠", x: 197, y: 463 },
  ],
  "(Ma)": [
    { label: "❤️ 🏠", x: 197, y: 115 },
    { label: "❤️ 🏠", x: 197, y: 463 },
  ],
  Ju: [
    { label: "❤️ 🏠", x: 81, y: 115 },
    { label: "❤️ 🏠", x: 81, y: 463 },
  ],
  "(Ju)": [
    { label: "❤️ 🏠", x: 81, y: 115 },
    { label: "❤️ 🏠", x: 81, y: 463 },
  ],
  Sa: [
    { label: "❤️ 🏠", x: 81, y: 347 },
    { label: "❤️ 🏠", x: 81, y: 231 },
  ],
  "(Sa)": [
    { label: "❤️ 🏠", x: 81, y: 347 },
    { label: "❤️ 🏠", x: 81, y: 231 },
  ],
};
export default ownHouse;
